import * as types from "./sb_actionTypes";
import * as HeaderAuthentication from '../../HeaderAuthentication'
import { baseURL } from "../../BaseURL";
import { getToataldataCount } from "../action";

let headerAuth = HeaderAuthentication.getRequestOptions;
const signInDetails = JSON.parse(sessionStorage.getItem("SignInDetails"));


// #region store function to store data to reducer
const getSubscriptionData = (subscriptonData) => ({
    type: types.get_subscription_data,
    payload: subscriptonData
})
const getSubscriptionSummary = (subscriptonSummary) => ({
    type: types.get_subscription_summary,
    payload: subscriptonSummary
})
export const getToatalPages = (totalPages) => ({
    type: types.get_total_pages,
    payload: totalPages
})
// #endregion

// #region call api functions
export const loadSubscriptionData = (params) => {
    return function (dispatch, getState) {
        return fetch(`${baseURL}/Users/get_subscription_data?page=${params.page}&page_size=${params.page_size}&search_text=${params.search_text}&subscription_type=${params.sbn_type}&plan_type=${params.plan_type}&status=${params.active_status}&from_date=${params.from_date}&to_date=${params.to_date}`, headerAuth)
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.status_code === 200) {
                    if (params.page > 1) {
                        const state = getState();
                        const currentSubscriptions = state.sbndata?.subscriptonData || [];

                        const updatedSubscriptions = [...currentSubscriptions, ...resp.subscriptions];
                        dispatch(getSubscriptionData(updatedSubscriptions));
                    } else {
                        // Fresh search or Page 1 -> Wipe and replace
                        dispatch(getSubscriptionData(resp.subscriptions));
                    }
                    dispatch(getSubscriptionSummary(resp.summary))
                    dispatch(getToataldataCount(resp.total_records))
                    dispatch(getToatalPages(resp.total_pages))

                    return resp;
                }
            })
            .catch((err) => {

            })
    }
}
// #endregion